const ArticleData = [
  {
    title: "Integrating FlashTalking library via code",
    url: "/article/api-ft",
    category: "Creative",
  },
  {
    title: "Dynamic creative submission guidelines",
    url: "/article/dynamic-creative-guidelines",
    category: "Creative",
  },
  {
    "title": "Campaign Briefing",
    "url": "/briefing-campaign",
    "category": "Strategic"
  }
];

export default ArticleData;
